<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">布置作业</p>
				</div>
				<div class="task_nav_cont flex">
					<div class="task_nav_list radius8 bs">
						<img src="../../../static/task_nav_01.png" class="task_nav_list_l" />
						<div class="task_nav_list_r">
							<h3 class="f26px cl_dark">学科作业</h3>
							<h4 class="f16px cl_gray mat5">9大学科，优质视频、题库资源，单选题自动批改</h4>
							<div class="task_nav_list_btm tc mat30">
								<router-link to="/task_video" class="cl_violet task_nav_list_item">视频作业</router-link>
								<router-link to="/task_paper" class="cl_violet task_nav_list_item">试卷作业</router-link>
								<router-link to="/task_topic" class="cl_violet task_nav_list_item">习题作业</router-link>
								<!-- <router-link to="" class="cl_violet task_nav_list_item">错题本</router-link> -->
							</div>
						</div>
					</div>
					<div class="task_nav_list radius8 bs">
						<img src="../../../static/task_nav_02.png" class="task_nav_list_l" />
						<div class="task_nav_list_r">
							<h3 class="f26px cl_dark">校本作业</h3>
							<h4 class="f16px cl_gray mat5">9大学科，优质视频、题库资源，单选题自动批改</h4>
							<div class="task_nav_list_btm tc mat30">
								<!-- <router-link to="/school_video" class="cl_violet task_nav_list_item">视频作业</router-link> -->
								<router-link to="/school_paper" class="cl_violet task_nav_list_item">试卷作业</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 2,
					listCur: 0,
					open: 0,
				},
			}
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			
		},
	}
</script>

<style>
</style>
